define('productDetailsAndDimensions/productDetailsAndDimensions',[
],
    function () {

        const componentSelector = ".product-details-and-dimensions";
        const itersEcersSelector = ".rating-scale";
        const componentTitleSelector = "#details-and-dimensions";
        const dimensionsWrapperSelector = ".dimensions-wrapper";
        const dimensionsChangeList = [
            { selector: ".height", wrapperSelector: ".height-wrapper", data: "height" },
            { selector: ".depth", wrapperSelector: ".depth-wrapper", data: "depth" },
            { selector: ".width", wrapperSelector: ".width-wrapper", data: "width" },
            { selector: ".length", wrapperSelector: ".length-wrapper", data: "length" }
        ];
        const detailsChangeList = [
            { selector: ".details", wrapperSelector: ".details-wrapper", data: "details" }
        ];
        const ageRangeChangeList = [
            { selector: ".age-range", wrapperSelector: ".age-range-wrapper", data: "ageRange" }
        ];

        function displayVariantData(variantGuid) {
            var variant = productDetailsAndDimensions.variants[variantGuid];
            if (variant) {
                var componentElement = $(componentSelector);
                var displayed = {
                    dimensions: false,
                    details: false,
                    image: false,
                    itersEcers: false
                };
                // change text elements for dimensions
                dimensionsChangeList.forEach(function (change) {
                    var value = variant[change.data];
                    $(componentElement).find(change.selector).empty().html(value);
                    if (value) {
                        // this dimension has value - display its wrapper as well.
                        $(componentElement).find(change.wrapperSelector).removeClass("d-none");
                        displayed.dimensions = true;
                    } else {
                        // this dimension doesn't have value - hide the wrapper.
                        $(componentElement).find(change.wrapperSelector).addClass("d-none");
                    }
                });
                // If there's any dimension displayed - display the title as well. Otherwise hide it.
                if (displayed.dimensions) {
                    $(componentElement).find(dimensionsWrapperSelector).removeClass("d-none");
                } else {
                    $(componentElement).find(dimensionsWrapperSelector).addClass("d-none");
                }
                // change text for details
                detailsChangeList.forEach(function (change) {
                    var value = variant[change.data];
                    $(componentElement).find(change.selector).empty().html(value);
                    if (value) {
                        // has value - display the wrapper as well
                        $(componentElement).find(change.wrapperSelector).removeClass("d-none");
                        displayed.details = true;
                    } else {
                        // doesn't have value - hide the wrapper
                        $(componentElement).find(change.wrapperSelector).addClass("d-none");
                    }
                });
                // change text for age range
                ageRangeChangeList.forEach(function (change) {
                    var value = variant[change.data];
                    $(componentElement).find(change.selector).empty().html(value);
                    if (value) {
                        // has value - display the wrapper as well
                        $(componentElement).find(change.wrapperSelector).removeClass("d-none");
                        displayed.details = true;
                    } else {
                        // doesn't have value - hide the wrapper
                        $(componentElement).find(change.wrapperSelector).addClass("d-none");
                    }
                });
                // change image url
                if (variant.imageUrl) {
                    var imageElement = $(componentElement).find(".dimensions-image");
                    var currentImageUrl = $(imageElement).attr("src");
                    if (variant.imageUrl !== currentImageUrl) {
                        $(imageElement)
                            .addClass("opacity-05")
                            .attr("src", variant.imageUrl)
                            .attr("width", variant.imageWidth)
                            .attr("height", variant.imageHeight)
                            .one("load", function () { $(this).removeClass("opacity-05") });
                    }
                    $(componentElement).find(".dimensions-image-wrapper").removeClass("d-none");
                    displayed.image = true;
                } else {
                    $(componentElement).find(".dimensions-image-wrapper").addClass("d-none");
                }
                //do we have iters and ecers?
                if ($(componentElement).find(itersEcersSelector).length) {
                    displayed.itersEcers = true;
                }
                // If there's something displayed - display the component title as well. Otherwise hide it.
                if (displayed.details || displayed.dimensions || displayed.image || displayed.itersEcers) {
                    $(componentTitleSelector).removeClass("d-none");
                } else {
                    $(componentTitleSelector).addClass("d-none");
                }
            }
        }

        return {
            displayVariantData: displayVariantData
        };
    });

